// Events
import { THEME_WISHLIST_UPDATED } from 'events';
import { component } from 'picoapp';

export default component(async (node, ctx) => {
  const render = (wishlist) => {
    const count = wishlist.length;

    if (count > 0) {
      node.hidden = false;
      node.textContent = count.toString();
    } else {
      node.hidden = true;
      node.textContent = '';
    }
  };

  render(ctx.getState().wishlist);
  ctx.on(THEME_WISHLIST_UPDATED, ({ wishlist }) => render(wishlist));
});
